import styled from 'styled-components';

export const Header = styled.header.attrs({ className: 'full-width' })`
  background: var(--white);
  border-bottom: 1px solid #f5f5f5;
`;

export const InnerWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  max-width: 945px;
  margin-inline: auto;
  padding: var(--spacing-large);
`;
